import { TFunction } from 'i18next';
import BranchStatus from '../../pages/branches/enums/branch-status.enum';

const getBranchStatusData = (t: TFunction) => [
    { value: BranchStatus.approved.toString(), label: t('Aprovado') },
    { value: BranchStatus.repproved.toString(), label: t('Reprovado') },
    { value: BranchStatus.requested.toString(), label: t('Solicitado') },
];

export default getBranchStatusData;
